const breakpoints = { mobile: '37.5em', tablet: '64em' };
const elevations = {
  elevation1: '0px 1px 2px rgba(0, 0, 0, 0.3), 0px 1px 3px 1px rgba(0, 0, 0, 0.15)',
  elevation2: '0px 1px 2px rgba(0, 0, 0, 0.3), 0px 2px 6px 2px rgba(0, 0, 0, 0.15)',
  elevation3: '0px 4px 8px 3px rgba(0, 0, 0, 0.15), 0px 1px 3px rgba(0, 0, 0, 0.3)',
  elevation4: '0px 6px 10px 4px rgba(0, 0, 0, 0.15), 0px 2px 3px rgba(0, 0, 0, 0.3)',
  elevation5: '0px 8px 12px 6px rgba(0, 0, 0, 0.15), 0px 4px 4px rgba(0, 0, 0, 0.3)',
  ibisShadow: 'rgba(99, 99, 99, 0.2) 0px 2px 8px 0px',
};

const defaultTheme = {
  colors: {
    primary: '#259D90',
    primaryTint: '#C1EDED',
    secondary: '#6DC89D',
    secondaryDark: '#269561',
    callToAction: '#9086FF',
    negativeLight: '#F2E6E6',
    negativeDark: '#870000',
    neutralLight: '#AAB2B2',
    neutralDark: '#414143',
    backgroundNeutral: '#FFFBFE',
    backgroundShade: '#EAF8F8',
    warning: '#F0B729',
    info: '#299CF0',
    success: '#269561',
    error: '#870000',
    gradient: 'linear-gradient(138.24deg, #0088A1 -6.34%, #55D99D 100%)',
  },
};

export const theme = {
  ...defaultTheme,
  breakpoints,
  elevations,
};
